import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable()
export class CanActivateStyleguide implements CanActivate {
  constructor(private router: Router) {}

  public canActivate(): boolean {
    if (environment.production) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
